import React from 'react';
import { Box, Button, Dialog, DialogContent, DialogActions, Zoom } from '@mui/material';
import { HeaderTypography } from "../../styles/style";
import DataSourceContext from "../../context/DataSourceMngContext";

//icons
import { GradienCheckCircleIcon, GradienWarningIcon, GradienCancelIcon, GradienInFoIcon } from "../../component/icons/icon-gradient";

export default function DialogDialogWarning() {

  const { warning, setDataState } = React.useContext(DataSourceContext);

  const handleClose = () => {
    setDataState((s) => ({
      ...s,
      warning: {
        ...s.warning,
        open: false
      }
    }));
  };
  return (
    <Dialog open={warning?.open} sx={{ overflow: 'visible', "& .MuiPaper-root": { maxHeight: 200, minWidth: 400 } }} TransitionComponent={Zoom}>
      <DialogContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Box>
          {/* <Box sx={{ display: 'flex', justifyContent: "center" }}>
            <IconTitle status={warning?.severity} />
          </Box> */}
          <HeaderTypography sx={{ display: 'flex', justifyContent: "center", paddingTop: '15px' }}>
            {warning?.warningTitle}
          </HeaderTypography>
          {warning?.warningText &&
            <HeaderTypography sx={{ display: 'flex', justifyContent: "center", fontSize: '18px', padding: '0 10px' }}>
              {warning?.warningText}
            </HeaderTypography>
          }
        </Box>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
        {warning?.cancelBtnText &&
          <Button variant="outlined" color="primary" onClick={warning?.handleCancle || handleClose}>
            {warning?.cancelBtnText}
          </Button>
        }
        {warning?.okBtnText &&
          <Button variant="contained" color={warning?.severity === 'error' ? 'error' : 'primary'} onClick={warning?.handleOkClicked}>
            {warning?.okBtnText}
          </Button>
        }
      </DialogActions>
    </Dialog>
  );
};

function IconTitle({ status }) {
  const Content = (() => {
    switch (status) {
      case 'success':
        return <GradienCheckCircleIcon fontSize={100} />;
      case 'warning':
        return <GradienWarningIcon fontSize={50} />;
      case 'error':
        return <GradienCancelIcon fontSize={100} />;
      case 'info':
        return <GradienInFoIcon fontSize={80} />;
      default:
        return null;
    }
  })();
  return Content;
}